
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useStore } from '@/plugins/store/index';

export default defineComponent({
    computed: {
        ...mapState(useStore, ['diaryStatistics']),
    },
});
